"use client";

import React from "react";
import { Bell, X } from "lucide-react";

import { Paragraph } from "@/components/ui/typography";
import { Button } from "@/components/ui/button";
import Link from "@/components/link";

import useMoengageEventTracker from "@/hooks/use-moengage";

import EVENT_NAME from "@/hooks/use-moengage/event-name.json";
import EVENT_ATTRIBUTE from "@/hooks/use-moengage/event-attribute.json";

import { cn, formatCurrency, getContinuePurchaseCourses } from "@/lib/utils";

function PurchaseNowAnnouncement() {
  const trackMoengageEvent = useMoengageEventTracker();

  const [course, setCourse] = React.useState(null);

  React.useEffect(() => {
    const continuePurchaseCourses = getContinuePurchaseCourses();
    if (continuePurchaseCourses.length) {
      setCourse(continuePurchaseCourses.reverse()[0]);
    }
  }, []);

  if (!course) return null;

  const handleOnClick = () => {
    trackMoengageEvent(EVENT_NAME.POP_UP_CLICKED, {
      [EVENT_ATTRIBUTE.TYPE]: "continue_purchase",
    });
  };

  return (
    <div className="relative container-studyiq mx-auto flex flex-col mt-6">
      <div
        className={cn(
          "flex items-center w-full h-11.75 text-secondary-strong",
          "bg-[url('/studyiq-next/images/homepage/purchase-now-announcement-topbar-bg.png')]",
          "bg-cover pt-2 pb-4.25 px-6"
        )}
      >
        <Bell fill="currentColor" className="size-4 lg:size-6" />
        <span className="ml-2">Complete your purchase now!</span>
      </div>

      <div
        className={cn(
          "flex flex-col md:flex-row lg:items-center justify-between py-1.25 lg:py-3.5 px-3 lg:px-6 -mt-3",
          "rounded-xl bg-primary-foreground border border-grayscale-line"
        )}
      >
        <Paragraph variant="b4" as="span" className="hidden md:inline">
          {course.title || "No Course Title"}
        </Paragraph>

        <Paragraph variant="b3" as="span" className="md:hidden">
          {course.title || "No Course Title"}
        </Paragraph>

        <div className="flex items-center justify-between gap-x-4">
          <div className="flex items-center gap-x-1.5">
            <Paragraph
              variant="b3"
              weight="sb"
              className="text-grayscale-header"
            >
              {formatCurrency(course.discountPrice || 0)}
            </Paragraph>

            <Paragraph
              variant="b3-tight"
              weight="sb"
              className="line-through text-grayscale-placeholder"
            >
              {formatCurrency(course.basePrice || 0)}
            </Paragraph>
          </div>

          <Button size="small" className="hidden md:inline-flex" asChild>
            <Link
              href={`/course-detail/${course.slug}`}
              onClick={handleOnClick}
            >
              CONTINUE PURCHASE
            </Link>
          </Button>

          <Link
            href={`/course-detail/${course.slug}`}
            className="md:hidden text-xs text-primary"
            onClick={handleOnClick}
          >
            Continue Purchase
          </Link>
        </div>
      </div>

      <Button
        size="icon"
        className={cn(
          "absolute -top-2 -right-2 hidden md:flex items-center justify-center",
          "size-6 rounded-full bg-grayscale-input! text-grayscale-header"
        )}
        onClick={() => setCourse(null)}
      >
        <X />
      </Button>
    </div>
  );
}

export default PurchaseNowAnnouncement;
